export default "__VITE_ASSET__fd221f50__"